import Marquee from "react-fast-marquee";
import "./Sliders.scss";

const Sliders = () => {
  const testimonials = [
    {
      id: 1,
      name: "Fondazione GraphiTech",
      role: "Owner",
      message:
        "This service completely exceeded our expectations. The team was professional and the results were outstanding.",
    },
    {
      id: 2,
      name: "Mike Russell",
      role: "Brandify",
      message:
        "A fantastic experience from start to finish. Communication was smooth and the project was delivered on time.",
    },
    {
      id: 3,
      name: "This Is PPC",
      role: "Founder",
      message:
        "Their attention to detail and creative solutions helped us scale our business faster than we imagined.",
    },
  ];

  // Duplicate the array to avoid gap
  const loopTestimonials = [...testimonials, ...testimonials];

  return (
    <Marquee gradient={false} speed={40} loop={0}>
      {loopTestimonials.map((t, index) => (
        <div key={index} className="slider-card">
          <p className="slider-message">“{t.message}”</p>
          <h4>{t.name}</h4>
          <span>{t.role}</span>
        </div>
      ))}
    </Marquee>
  );
};

export default Sliders;
